import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5b363486"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护系统角色信息。")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}角色`), 1)]), _createTextVNode("description-header-title "), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      "label-width": "120px",
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "角色名称",
        prop: "roleName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.roleName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.roleName = $event),
          placeholder: "请输入角色名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _ctx.isAdmin ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: "所属机构"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.formModel.orgId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.orgId = $event),
          placeholder: "请选择所属机构",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.orgList, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.orgId,
              label: item.orgName,
              value: item.orgId
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
        label: "备注",
        prop: "remark"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.remark,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.remark = $event),
          type: "textarea",
          placeholder: "请输入备注"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['role_add', 'role_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  })]);
}